module.exports = __webpack_public_path__ + "img/stamm.be0e8603.svg";